import React from 'react';
import { useDroppable } from '@dnd-kit/core';
import { CornerLeftUp, FolderOpen } from 'lucide-react';
import { ButtonWithIcon } from '@/common/components/Button/ButtonWithIcon.tsx';
import { FlexBox } from '@/common/components/Box/FlexBox.tsx';

interface DroppableFolderUpButtonProps {
  onGoUp: () => void;
  onDrop?: (itemId: string) => void;
  tooltip?: string;
}

export const FOLDER_UP_DROPPABLE_ID = 'folder-up-droppable';

export const DroppableFolderUpButton: React.FC<DroppableFolderUpButtonProps> = (
  {
    onGoUp,
    onDrop,
    tooltip = 'Go one folder up',
  }) => {
  const {
    setNodeRef,
    isOver,
    active,
  } = useDroppable({
    id: FOLDER_UP_DROPPABLE_ID,
    data: {
      onDrop,
    },
  });

  const showFolderIcon = isOver && active;

  const handleGoUp = () => {
    if (!active) {
      onGoUp();
    }
  };

  return (
    <FlexBox ref={setNodeRef}>
      <ButtonWithIcon
        icon={showFolderIcon ? <FolderOpen /> : <CornerLeftUp />}
        tooltip={showFolderIcon ? "Drop here to move to parent folder" : tooltip}
        size={"small"}
        onClick={handleGoUp}
        sx={{
          borderColor: isOver ? 'primary.main' : 'inherit',
          backgroundColor: isOver ? 'rgba(25, 118, 210, 0.08)' : 'inherit',
        }}
      />
    </FlexBox>
  );
};
